import {ShieldLockIcon} from '@primer/octicons-react'
/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash, Link} from '@primer/react'
import type {CopilotAgentError} from '@github-ui/copilot-chat-types'
import {ssrSafeWindow} from '@github-ui/ssr-utils'

import styles from './SingleSignOnBanner.module.css'

export function SSOBannerFromError({error, className}: {error: CopilotAgentError; className?: string}) {
  // identifier comes from X-GitHub-SSO header e.g.
  // "required; url=http://github.localhost/orgs/fabrikam/sso?authorization_request=ABC"
  const identifier = error.identifier || ''
  const authorizeUrl = identifier.split('url=')[1] || ''
  const orgMatch = identifier.match(/\/([^/]+)\/sso/)
  const org = (orgMatch && orgMatch[1]) || ''

  if (!org || !authorizeUrl) {
    return null
  }

  return (
    <div className={className} data-testid="sso-banner">
      <div className={styles.bannerContainer}>
        <section aria-label="Single sign-on information">
          <Flash className={styles.Flash}>
            <div>
              <ShieldLockIcon />
              <Link inline href={buildAuthorizeUrl({authorizeUrl})}>
                Single sign-on
              </Link>{' '}
              to see results in the <b>{org}</b> organization.
            </div>
          </Flash>
        </section>
      </div>
    </div>
  )
}

function buildAuthorizeUrl({authorizeUrl}: {authorizeUrl: string}): string {
  const location = ssrSafeWindow?.location

  if (!location) {
    return authorizeUrl
  }

  try {
    const url = new URL(authorizeUrl, location.origin)
    url.searchParams.set('return_to', location.toString())
    return url.toString()
  } catch {
    return authorizeUrl
  }
}
